import React, { useState, useEffect } from 'react';

const CookieNotice = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Sprawdź czy użytkownik już zaakceptował cookies
    const cookieAccepted = localStorage.getItem('cookieAccepted');
    if (!cookieAccepted) {
      setIsVisible(true);
    }
  }, []);

  const acceptCookies = () => {
    localStorage.setItem('cookieAccepted', 'true');
    setIsVisible(false);
  };

  const declineCookies = () => {
    localStorage.setItem('cookieAccepted', 'false');
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div className="fixed bottom-4 left-4 z-50 max-w-sm">
      <div className="glass rounded-lg p-4 shadow-2xl border border-gray-600">
        <div className="flex items-start space-x-3">
          <div className="flex-shrink-0">
            <svg className="w-6 h-6 text-blue-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
            </svg>
          </div>
          <div className="flex-1">
            <h3 className="text-sm font-semibold text-white mb-2">
              Informacja o plikach cookie
            </h3>
            <p className="text-xs text-gray-300 mb-3">
              Ta strona wykorzystuje pliki cookie w celu zapewnienia najlepszej jakości usług. 
              Kontynuując przeglądanie, wyrażasz zgodę na ich wykorzystywanie.
            </p>
            <div className="flex space-x-2">
              <button
                onClick={acceptCookies}
                className="px-3 py-1.5 bg-gradient-to-r from-green-500 to-green-600 hover:from-green-600 hover:to-green-700 text-white text-xs font-medium rounded transition-all duration-200 hover:scale-105"
              >
                Akceptuję
              </button>
              <button
                onClick={declineCookies}
                className="px-3 py-1.5 bg-gradient-to-r from-gray-600 to-gray-700 hover:from-gray-700 hover:to-gray-800 text-white text-xs font-medium rounded transition-all duration-200 hover:scale-105"
              >
                Odrzuć
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CookieNotice;